var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:("chat chat--" + _vm.type),attrs:{"type":"button"},on:{"click":_vm.openChat}},[_c('chat',{tag:"component",staticClass:"page-header__icon page-header__icon--right"}),_c('div',{staticClass:"chat-txt"},[_vm._v("Chat")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }